/* eslint-disable no-undef */
export const api = {
	manageApiUrl: process?.env?.NEXT_PUBLIC_MANAGMENT_DASHBOARD_API || "https://dev-manage-api.konfhub.com",
	authApiUrl: process?.env?.NEXT_PUBLIC_API_URL || "https://dev-api.konfhub.com",
	apiUrl: process?.env?.NEXT_PUBLIC_API_URL || "https://dev-api.konfhub.com",
	pollerApiUrl: process?.env?.NEXT_PUBLIC_POLLER_ENDPOINT || "https://dev-regional-api.konfhub.com"
};
